export const ROUTES = {
  ROOT: '/',

  // common routes
  SIGN_UP: '/signup',
  SIGN_UP_DEPRECATED: '/sign-up',
  SIGN_IN: '/login',
  SIGN_IN_DEPRECATED: '/sign-in',
  RESET_PASSWORD: '/reset-password',
  ACCEPT_INVITE: '/accept-invite',
  ONBOARDING_START: '/onboarding-start',
  UPGRADE: '/upgrade',
  CHECKOUT: '/upgrade/checkout',
  DASHBOARD: '/dashboard',
  PROJECTS: '/projects',
  INTEGRATIONS_RESOURCES: '/integrations-resources',
  ANALYTICS: '/analytics',
  WEBSITE_AUTOMATION: '/website-automation',
  TALKING_POINTS: '/talking-points',
  TEMPLATE_BUILDER: '/template-builder',
  SAVED_PROMPTS: '/prompts',
  SETTINGS: '/settings',
  SETTINGS_USAGE_REPORT: '/usage-dashboard',
  NOT_VERIFIED: '/verification',
  MOBILE: '/mobile',
  LOCKED: '/locked',
  FILE_VIEWER: '/file-viewer',
  SHARED: '/shared',
  MULTI_PROMPT_BUILDER: '/multi-prompt-builder',

  // brand-voice and it's entities
  BRAND_VOICE: '/brand-voice',
  BRAND_TERMS: '/brand-terms',
  BRAND_BRIEFS: '/messaging-bank',
  TONE_OF_VOICE: '/tone-of-voice',
  CUSTOM_MODELS: '/custom-models',
  PERSONAS: '/target-audiences',
  FORMAT: '/format',
  CUSTOM_FORMULA: '/custom-formula',

  // visual language and its entities
  VISUAL_LANGUAGE: '/visual-language',
  IMAGE_STYLE: '/image-style',

  // extension and landing related routes
  EXTERNAL_SIGNUP: '/external-signup',
  EXTERNAL_INFINITY_EXTENSION: '/external-infinity-extension',
  EXTENSION_ONBOARDING: '/extension-onboarding',
  EXTENSION_UNINSTALLED: '/extension-uninstalled',

  // integrations
  LINKEDIN_AUTH_CALLBACK: '/linkedin/callback',
  GOOGLE_AUTH_CALLBACK: '/google/callback',
  TWITTER_AUTH_CALLBACK: '/twitter/callback',
  TWITTER_SOCIAL_AUTH_CALLBACK: '/twitter_social/callback',
  HUBSPOT_AUTH_CALLBACK: '/hubspot/callback',
  SPRINKLR_AUTH_CALLBACK: '/sprinklr/callback',
  SALESFORCE_AUTH_CALLBACK: 'salesforce/callback',
  SALESFORCE_CRM_AUTH_CALLBACK: 'salesforce-crm/callback',
  MS_DYNAMICS_CRM_AUTH_CALLBACK: 'microsoft_dynamics_sales/callback',
  OAUTH_CALLBACK: '/oauth-callback',
  /** OAuth: show "Allow app to connect to Anyword?" before redirecting to /oauth/authorize */
  OAUTH_CONSENT: '/oauth-consent',
  SAML_CALLBACK: '/saml/callback',
  VERIFY_EMAIL_CALLBACK: '/verify-email-callback',
  MAGIC_LINK_CALLBACK: '/magic-link-callback',
} as const;
export type Route = (typeof ROUTES)[keyof typeof ROUTES];

export const ROUTE_PARAMS = {
  generationTool: 'generation-tool',
  toolCategory: 'tool-category',
  subTemplateId: 'sub-template-id',
  customMultiPromptId: 'custom-multi-prompt-id',
  customMultiPromptGroup: 'custom-multi-prompt-group',
  templateType: 'template-type',
  creation: 'creation',
  createNew: 'create-new',
  datasetId: 'dataset',
  freestyleGenerationToolId: 'custom-generation-tool-id',
  userCreated: 'userCreated',
  token: 'token',
  view: 'view',
  templatesPopup: 'templates-popup',
  improveContentType: 'improve-content-type',
  textToImprove: 'text-to-improve',
  keywords: 'keywords',
  createNewScoringModel: 'create-new-scoring-model',
  applicationMode: 'application-mode',
  host: 'host',
  installationId: 'installation-id',
  source: 'source',
  autoClose: 'auto-close',

  newPlan: 'new-plan',
  newTier: 'new-tier',
  billingCycle: 'billing_cycle',
  coupon: 'coupon',

  customerId: 'customer_id',
  redirectTo: 'redirect_to',
  oauth2Consent: 'oauth2_consent', // OAuth flow: redirect here after login (e.g. /oauth/authorize URL)
  returnTo: 'return_to',
  channel: 'channel',
  accountId: 'account-id',
  table: 'table',
  scrollTo: 'scrollTo',

  integration: 'integration',
  autoOpen: 'auto-open',
  resources: 'resources',
  checkout: 'checkout',

  folder: 'folder',

  panel: 'panel',

  // Deprecated and not used anymore on the Platform, but we still might get these params from 3rd-party integrations
  // generateFrom: 'generate-from',
  // assetType: 'asset-type',
  // walkthroughSkipped: 'walkthroughSkipped',
  // planCategory: 'plan_category',
} as const;
export type RouteParam = (typeof ROUTE_PARAMS)[keyof typeof ROUTE_PARAMS];
